import {useState} from "react";
import {Calendar, StickyHeader, ShadowBox, YStack} from "@chayka/ui";
import {getMaxViewDate, getMinBookingDate, startOfDay} from "@chayka/utils";
import {trpc} from "@/app/trpc";
import {useQuery} from "@tanstack/react-query";
import {BackButton} from "@/components";

export const SchedulePage = ({withBackButton}: {withBackButton?: boolean}) => {
  const [date, setDate] = useState<Date>(getMinBookingDate());
  const {data} = useQuery(trpc.schedule.list.queryOptions({}));

  const highlightedDates = data?.map((item) => new Date(item.date)) ?? [];

  const workingHours = data?.find(
    (item) => startOfDay(new Date(item.date)).getTime() === startOfDay(date).getTime(),
  )?.hours;

  return (
    <>
      <StickyHeader
        title="График работы студии"
        leftPart={withBackButton ? <BackButton /> : undefined}
      />
      <Calendar
        minDate={getMinBookingDate()}
        maxDate={getMaxViewDate()}
        highlightedDates={highlightedDates}
        onChange={(nextDate) => setDate(startOfDay(nextDate))}
        value={date}
      />
      <ShadowBox className="p-4 rounded-xl">
        {workingHours !== undefined && (
          <YStack className="gap-2 items-center">
            {workingHours ? (
              <>
                <div className="font-bold">Рабочие часы:</div>
                <div>{`${workingHours.from} - ${workingHours.to}`}</div>
              </>
            ) : (
              <div className="font-bold">Студия закрыта</div>
            )}
          </YStack>
        )}
        {workingHours === undefined && (
          <YStack className="gap-2 items-center">
            <div className="text-center font-bold">Студия работает по стандартному графику</div>
            <div>Пн-Вс: 9:00–00:00</div>
          </YStack>
        )}
      </ShadowBox>
    </>
  );
};
